'use client'

import { useLocaleBanner } from '@/hooks/useLocaleBanner'
import { cn } from '@desoutter/uikit'
import { CSSProperties, forwardRef } from 'react'

type HeroWrapperProps = {
	children?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const HeroWrapper = forwardRef<HTMLDivElement, HeroWrapperProps>(
	({ children, className, style, ...props }, ref) => {
		const showBanner = useLocaleBanner()

		return (
			<div
				ref={ref}
				className={cn(
					'relative pt-[var(--padding-mobile)] md:pt-[var(--padding-desktop)]',
					className,
				)}
				style={
					{
						'--padding-mobile': showBanner
							? 'calc(var(--height-banner-mobile) + var(--height-header))'
							: 'var(--height-header)',
						'--padding-desktop': showBanner
							? 'calc(var(--height-banner-desktop) + var(--height-header))'
							: 'var(--height-header)',
						...style,
					} as CSSProperties
				}
				{...props}
			>
				{children}
			</div>
		)
	},
)

HeroWrapper.displayName = 'HeroWrapper'

export const HeroWrapperDark = forwardRef<HTMLDivElement, HeroWrapperProps>(
	({ children, className, style, ...props }, ref) => {
		const showBanner = useLocaleBanner()

		return (
			<div
				ref={ref}
				className={cn(
					'relative top-[calc(var(--top-mobile)*-1)] md:top-[calc(var(--top-desktop)*-1)]',
					className,
				)}
				style={
					{
						'--top-mobile': showBanner
							? 'calc(var(--height-banner-mobile) + var(--height-header))'
							: 'var(--height-header)',
						'--top-desktop': showBanner
							? 'calc(var(--height-banner-desktop) + var(--height-header))'
							: 'var(--height-header)',
						...style,
					} as CSSProperties
				}
				{...props}
			>
				{children}
			</div>
		)
	},
)

HeroWrapperDark.displayName = 'HeroWrapperDark'
